module.exports = __webpack_public_path__ + "img/teacher.64bd38f2.png";